export const getAllAccountAddresses = async () => {
    let data = [];
    let pagination = { offset: '', total: 0 };

    do {
        const response = (await ApiClient.get('/addresses', { offset: pagination.offset })).data;
        pagination = response?.pagination ?? pagination;
        data = data.concat(response?.data ?? []);
    } while (data.length < pagination.total);
    return data;
};

export const getEInvoicingStatus = () => {
    return ApiClient.get('/account/e-invoicing/status');
};

export const getEInvoicingMandate = () => {
    return ApiClient.get('/account/e-invoicing/mandate');
};

export const deletePendingEInvoicingMandate = () => {
    return ApiClient.del('/account/e-invoicing/mandate');
};

export const resendMandateSignatureEmail = () => {
    return ApiClient.post('/account/e-invoicing/mandate/send-email');
};
